<span>{{'history.event.' + eventName | translate:event?.details}}</span>
